import { simpleAlert } from "components/CommonLib/CommonLib";
import TextField from "components/LabelInput/TextField";
import NormalBtn from "components/NewButton/NormalBtn";
import { useDispatch } from "react-redux";

const SaveConditionModal = ({ modalParam, onModalDone }) => {
  const storesDispatch = useDispatch();

  const onSave = (canUseTm) => {
    simpleAlert(
      storesDispatch,
      "알림",
      canUseTm ? "저장하시겠습니까? (TM리스트 + 검색조건)" : "저장하시겠습니까? (검색조건)",
      false,
      undefined,
      () => {
        onModalDone("save", modalParam.condName, canUseTm ? canUseTm : false);
      },
    );
  };

  return (
    <div>
      <TextField
        marginTop="1rem"
        labelWidth="3rem"
        labelText="조건명"
        textBoxWidth="20rem"
        onChangeCallback={(e) => {
          modalParam.condName = e;
        }}
      />

      <div
        style={{ display: "flex", marginTop: "2.5rem", justifyContent: "center", gap: "0.25rem" }}
      >
        <NormalBtn
          name="TM리스트 + 조건 저장"
          theme="white"
          width="10.5rem"
          onClick={() => {
            onSave(true);
          }}
        />

        <NormalBtn
          name="조건만 저장"
          width="7.25rem"
          onClick={() => {
            onSave();
          }}
        />
      </div>
    </div>
  );
};
export default SaveConditionModal;
